/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Reporting
 * API for Vault Reporting
 *
 * The version of the OpenAPI document: 2025-05-05
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime.ts';
import type {
  RpcStatus,
  VaultReporting20250505FetchDistinctEntityIdsResponse,
  VaultReporting20250505FetchDistinctMountsResponse,
  VaultReporting20250505FetchDistinctNamespacesResponse,
  VaultReporting20250505FetchSecretsInventoryCountResponse,
  VaultReporting20250505FetchSecretsInventoryResponse,
} from '../models/index.ts';
import {
    RpcStatusFromJSON,
    RpcStatusToJSON,
    VaultReporting20250505FetchDistinctEntityIdsResponseFromJSON,
    VaultReporting20250505FetchDistinctEntityIdsResponseToJSON,
    VaultReporting20250505FetchDistinctMountsResponseFromJSON,
    VaultReporting20250505FetchDistinctMountsResponseToJSON,
    VaultReporting20250505FetchDistinctNamespacesResponseFromJSON,
    VaultReporting20250505FetchDistinctNamespacesResponseToJSON,
    VaultReporting20250505FetchSecretsInventoryCountResponseFromJSON,
    VaultReporting20250505FetchSecretsInventoryCountResponseToJSON,
    VaultReporting20250505FetchSecretsInventoryResponseFromJSON,
    VaultReporting20250505FetchSecretsInventoryResponseToJSON,
} from '../models/index.ts';

export interface VaultReportingServiceApiFetchDistinctEntityIdsRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    column?: FetchDistinctEntityIdsColumnEnum;
    paginationPageSize?: number;
    paginationNextPageToken?: string;
    paginationPreviousPageToken?: string;
}

export interface VaultReportingServiceApiFetchDistinctMountsRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    namespace?: string;
    mountPathPrefix?: string;
    paginationPageSize?: number;
    paginationNextPageToken?: string;
    paginationPreviousPageToken?: string;
}

export interface VaultReportingServiceApiFetchDistinctNamespacesRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    namespacePathPrefix?: string;
    paginationPageSize?: number;
    paginationNextPageToken?: string;
    paginationPreviousPageToken?: string;
}

export interface VaultReportingServiceApiFetchSecretsInventoryRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    filterIncludeDeleted?: boolean;
    filterSecretNames?: Array<string>;
    filterSecretTypes?: Array<string>;
    filterNamespaces?: Array<string>;
    filterMountPaths?: Array<string>;
    filterPluginNames?: Array<string>;
    filterPluginTypes?: Array<string>;
    filterCreatedAtOperator?: FetchSecretsInventoryFilterCreatedAtOperatorEnum;
    filterCreatedAtAbsolute?: Date;
    filterCreatedAtRelativeToNow?: string;
    filterCreatedByIds?: Array<string>;
    filterConfigLastModifiedAtOperator?: FetchSecretsInventoryFilterConfigLastModifiedAtOperatorEnum;
    filterConfigLastModifiedAtAbsolute?: Date;
    filterConfigLastModifiedAtRelativeToNow?: string;
    filterConfigLastModifiedByIds?: Array<string>;
    filterConfigLastAccessedAtOperator?: FetchSecretsInventoryFilterConfigLastAccessedAtOperatorEnum;
    filterConfigLastAccessedAtAbsolute?: Date;
    filterConfigLastAccessedAtRelativeToNow?: string;
    filterConfigLastAccessedByIds?: Array<string>;
    filterConfigDeletedAtOperator?: FetchSecretsInventoryFilterConfigDeletedAtOperatorEnum;
    filterConfigDeletedAtAbsolute?: Date;
    filterConfigDeletedAtRelativeToNow?: string;
    filterConfigDeletedByIds?: Array<string>;
    filterSecretLastModifiedAtOperator?: FetchSecretsInventoryFilterSecretLastModifiedAtOperatorEnum;
    filterSecretLastModifiedAtAbsolute?: Date;
    filterSecretLastModifiedAtRelativeToNow?: string;
    filterSecretLastModifiedByIds?: Array<string>;
    filterSecretLastAccessedAtOperator?: FetchSecretsInventoryFilterSecretLastAccessedAtOperatorEnum;
    filterSecretLastAccessedAtAbsolute?: Date;
    filterSecretLastAccessedAtRelativeToNow?: string;
    filterSecretLastAccessedByIds?: Array<string>;
    filterSecretDeletedAtOperator?: FetchSecretsInventoryFilterSecretDeletedAtOperatorEnum;
    filterSecretDeletedAtAbsolute?: Date;
    filterSecretDeletedAtRelativeToNow?: string;
    filterSecretDeletedByIds?: Array<string>;
    filterSecretUndeletedAtOperator?: FetchSecretsInventoryFilterSecretUndeletedAtOperatorEnum;
    filterSecretUndeletedAtAbsolute?: Date;
    filterSecretUndeletedAtRelativeToNow?: string;
    filterSecretUndeletedByIds?: Array<string>;
    filterSecretDestroyedAtOperator?: FetchSecretsInventoryFilterSecretDestroyedAtOperatorEnum;
    filterSecretDestroyedAtAbsolute?: Date;
    filterSecretDestroyedAtRelativeToNow?: string;
    filterSecretDestroyedByIds?: Array<string>;
    filterExpiresOrNextRotationAtOperator?: FetchSecretsInventoryFilterExpiresOrNextRotationAtOperatorEnum;
    filterExpiresOrNextRotationAtAbsolute?: Date;
    filterExpiresOrNextRotationAtRelativeToNow?: string;
    paginationPageSize?: number;
    paginationNextPageToken?: string;
    paginationPreviousPageToken?: string;
    sortingOrderBy?: Array<string>;
}

export interface VaultReportingServiceApiFetchSecretsInventoryCountRequest {
    organizationId: string;
    projectId: string;
    clusterId: string;
    filterIncludeDeleted?: boolean;
    filterSecretNames?: Array<string>;
    filterSecretTypes?: Array<string>;
    filterNamespaces?: Array<string>;
    filterMountPaths?: Array<string>;
    filterPluginNames?: Array<string>;
    filterPluginTypes?: Array<string>;
    filterCreatedAtOperator?: FetchSecretsInventoryCountFilterCreatedAtOperatorEnum;
    filterCreatedAtAbsolute?: Date;
    filterCreatedAtRelativeToNow?: string;
    filterCreatedByIds?: Array<string>;
    filterConfigLastModifiedAtOperator?: FetchSecretsInventoryCountFilterConfigLastModifiedAtOperatorEnum;
    filterConfigLastModifiedAtAbsolute?: Date;
    filterConfigLastModifiedAtRelativeToNow?: string;
    filterConfigLastModifiedByIds?: Array<string>;
    filterConfigLastAccessedAtOperator?: FetchSecretsInventoryCountFilterConfigLastAccessedAtOperatorEnum;
    filterConfigLastAccessedAtAbsolute?: Date;
    filterConfigLastAccessedAtRelativeToNow?: string;
    filterConfigLastAccessedByIds?: Array<string>;
    filterConfigDeletedAtOperator?: FetchSecretsInventoryCountFilterConfigDeletedAtOperatorEnum;
    filterConfigDeletedAtAbsolute?: Date;
    filterConfigDeletedAtRelativeToNow?: string;
    filterConfigDeletedByIds?: Array<string>;
    filterSecretLastModifiedAtOperator?: FetchSecretsInventoryCountFilterSecretLastModifiedAtOperatorEnum;
    filterSecretLastModifiedAtAbsolute?: Date;
    filterSecretLastModifiedAtRelativeToNow?: string;
    filterSecretLastModifiedByIds?: Array<string>;
    filterSecretLastAccessedAtOperator?: FetchSecretsInventoryCountFilterSecretLastAccessedAtOperatorEnum;
    filterSecretLastAccessedAtAbsolute?: Date;
    filterSecretLastAccessedAtRelativeToNow?: string;
    filterSecretLastAccessedByIds?: Array<string>;
    filterSecretDeletedAtOperator?: FetchSecretsInventoryCountFilterSecretDeletedAtOperatorEnum;
    filterSecretDeletedAtAbsolute?: Date;
    filterSecretDeletedAtRelativeToNow?: string;
    filterSecretDeletedByIds?: Array<string>;
    filterSecretUndeletedAtOperator?: FetchSecretsInventoryCountFilterSecretUndeletedAtOperatorEnum;
    filterSecretUndeletedAtAbsolute?: Date;
    filterSecretUndeletedAtRelativeToNow?: string;
    filterSecretUndeletedByIds?: Array<string>;
    filterSecretDestroyedAtOperator?: FetchSecretsInventoryCountFilterSecretDestroyedAtOperatorEnum;
    filterSecretDestroyedAtAbsolute?: Date;
    filterSecretDestroyedAtRelativeToNow?: string;
    filterSecretDestroyedByIds?: Array<string>;
    filterExpiresOrNextRotationAtOperator?: FetchSecretsInventoryCountFilterExpiresOrNextRotationAtOperatorEnum;
    filterExpiresOrNextRotationAtAbsolute?: Date;
    filterExpiresOrNextRotationAtRelativeToNow?: string;
}

/**
 * 
 */
export class VaultReportingServiceApi extends runtime.BaseAPI {

    /**
     */
    async fetchDistinctEntityIdsRaw(requestParameters: VaultReportingServiceApiFetchDistinctEntityIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchDistinctEntityIdsResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchDistinctEntityIds().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchDistinctEntityIds().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchDistinctEntityIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['column'] != null) {
            queryParameters['column'] = requestParameters['column'];
        }

        if (requestParameters['paginationPageSize'] != null) {
            queryParameters['pagination.page_size'] = requestParameters['paginationPageSize'];
        }

        if (requestParameters['paginationNextPageToken'] != null) {
            queryParameters['pagination.next_page_token'] = requestParameters['paginationNextPageToken'];
        }

        if (requestParameters['paginationPreviousPageToken'] != null) {
            queryParameters['pagination.previous_page_token'] = requestParameters['paginationPreviousPageToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/distinct-entity-ids`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchDistinctEntityIdsResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchDistinctEntityIds(requestParameters: VaultReportingServiceApiFetchDistinctEntityIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchDistinctEntityIdsResponse> {
        const response = await this.fetchDistinctEntityIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async fetchDistinctMountsRaw(requestParameters: VaultReportingServiceApiFetchDistinctMountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchDistinctMountsResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchDistinctMounts().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchDistinctMounts().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchDistinctMounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['namespace'] != null) {
            queryParameters['namespace'] = requestParameters['namespace'];
        }

        if (requestParameters['mountPathPrefix'] != null) {
            queryParameters['mount_path_prefix'] = requestParameters['mountPathPrefix'];
        }

        if (requestParameters['paginationPageSize'] != null) {
            queryParameters['pagination.page_size'] = requestParameters['paginationPageSize'];
        }

        if (requestParameters['paginationNextPageToken'] != null) {
            queryParameters['pagination.next_page_token'] = requestParameters['paginationNextPageToken'];
        }

        if (requestParameters['paginationPreviousPageToken'] != null) {
            queryParameters['pagination.previous_page_token'] = requestParameters['paginationPreviousPageToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/distinct-mounts`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchDistinctMountsResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchDistinctMounts(requestParameters: VaultReportingServiceApiFetchDistinctMountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchDistinctMountsResponse> {
        const response = await this.fetchDistinctMountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async fetchDistinctNamespacesRaw(requestParameters: VaultReportingServiceApiFetchDistinctNamespacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchDistinctNamespacesResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchDistinctNamespaces().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchDistinctNamespaces().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchDistinctNamespaces().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['namespacePathPrefix'] != null) {
            queryParameters['namespace_path_prefix'] = requestParameters['namespacePathPrefix'];
        }

        if (requestParameters['paginationPageSize'] != null) {
            queryParameters['pagination.page_size'] = requestParameters['paginationPageSize'];
        }

        if (requestParameters['paginationNextPageToken'] != null) {
            queryParameters['pagination.next_page_token'] = requestParameters['paginationNextPageToken'];
        }

        if (requestParameters['paginationPreviousPageToken'] != null) {
            queryParameters['pagination.previous_page_token'] = requestParameters['paginationPreviousPageToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/distinct-namespaces`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchDistinctNamespacesResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchDistinctNamespaces(requestParameters: VaultReportingServiceApiFetchDistinctNamespacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchDistinctNamespacesResponse> {
        const response = await this.fetchDistinctNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async fetchSecretsInventoryRaw(requestParameters: VaultReportingServiceApiFetchSecretsInventoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchSecretsInventoryResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchSecretsInventory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterIncludeDeleted'] != null) {
            queryParameters['filter.include_deleted'] = requestParameters['filterIncludeDeleted'];
        }

        if (requestParameters['filterSecretNames'] != null) {
            queryParameters['filter.secret_names'] = requestParameters['filterSecretNames'];
        }

        if (requestParameters['filterSecretTypes'] != null) {
            queryParameters['filter.secret_types'] = requestParameters['filterSecretTypes'];
        }

        if (requestParameters['filterNamespaces'] != null) {
            queryParameters['filter.namespaces'] = requestParameters['filterNamespaces'];
        }

        if (requestParameters['filterMountPaths'] != null) {
            queryParameters['filter.mount_paths'] = requestParameters['filterMountPaths'];
        }

        if (requestParameters['filterPluginNames'] != null) {
            queryParameters['filter.plugin_names'] = requestParameters['filterPluginNames'];
        }

        if (requestParameters['filterPluginTypes'] != null) {
            queryParameters['filter.plugin_types'] = requestParameters['filterPluginTypes'];
        }

        if (requestParameters['filterCreatedAtOperator'] != null) {
            queryParameters['filter.created_at.operator'] = requestParameters['filterCreatedAtOperator'];
        }

        if (requestParameters['filterCreatedAtAbsolute'] != null) {
            queryParameters['filter.created_at.absolute'] = (requestParameters['filterCreatedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterCreatedAtRelativeToNow'] != null) {
            queryParameters['filter.created_at.relative_to_now'] = requestParameters['filterCreatedAtRelativeToNow'];
        }

        if (requestParameters['filterCreatedByIds'] != null) {
            queryParameters['filter.created_by_ids'] = requestParameters['filterCreatedByIds'];
        }

        if (requestParameters['filterConfigLastModifiedAtOperator'] != null) {
            queryParameters['filter.config_last_modified_at.operator'] = requestParameters['filterConfigLastModifiedAtOperator'];
        }

        if (requestParameters['filterConfigLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.config_last_modified_at.absolute'] = (requestParameters['filterConfigLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_modified_at.relative_to_now'] = requestParameters['filterConfigLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastModifiedByIds'] != null) {
            queryParameters['filter.config_last_modified_by_ids'] = requestParameters['filterConfigLastModifiedByIds'];
        }

        if (requestParameters['filterConfigLastAccessedAtOperator'] != null) {
            queryParameters['filter.config_last_accessed_at.operator'] = requestParameters['filterConfigLastAccessedAtOperator'];
        }

        if (requestParameters['filterConfigLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.config_last_accessed_at.absolute'] = (requestParameters['filterConfigLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_accessed_at.relative_to_now'] = requestParameters['filterConfigLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastAccessedByIds'] != null) {
            queryParameters['filter.config_last_accessed_by_ids'] = requestParameters['filterConfigLastAccessedByIds'];
        }

        if (requestParameters['filterConfigDeletedAtOperator'] != null) {
            queryParameters['filter.config_deleted_at.operator'] = requestParameters['filterConfigDeletedAtOperator'];
        }

        if (requestParameters['filterConfigDeletedAtAbsolute'] != null) {
            queryParameters['filter.config_deleted_at.absolute'] = (requestParameters['filterConfigDeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigDeletedAtRelativeToNow'] != null) {
            queryParameters['filter.config_deleted_at.relative_to_now'] = requestParameters['filterConfigDeletedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigDeletedByIds'] != null) {
            queryParameters['filter.config_deleted_by_ids'] = requestParameters['filterConfigDeletedByIds'];
        }

        if (requestParameters['filterSecretLastModifiedAtOperator'] != null) {
            queryParameters['filter.secret_last_modified_at.operator'] = requestParameters['filterSecretLastModifiedAtOperator'];
        }

        if (requestParameters['filterSecretLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_modified_at.absolute'] = (requestParameters['filterSecretLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_modified_at.relative_to_now'] = requestParameters['filterSecretLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastModifiedByIds'] != null) {
            queryParameters['filter.secret_last_modified_by_ids'] = requestParameters['filterSecretLastModifiedByIds'];
        }

        if (requestParameters['filterSecretLastAccessedAtOperator'] != null) {
            queryParameters['filter.secret_last_accessed_at.operator'] = requestParameters['filterSecretLastAccessedAtOperator'];
        }

        if (requestParameters['filterSecretLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_accessed_at.absolute'] = (requestParameters['filterSecretLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_accessed_at.relative_to_now'] = requestParameters['filterSecretLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastAccessedByIds'] != null) {
            queryParameters['filter.secret_last_accessed_by_ids'] = requestParameters['filterSecretLastAccessedByIds'];
        }

        if (requestParameters['filterSecretDeletedAtOperator'] != null) {
            queryParameters['filter.secret_deleted_at.operator'] = requestParameters['filterSecretDeletedAtOperator'];
        }

        if (requestParameters['filterSecretDeletedAtAbsolute'] != null) {
            queryParameters['filter.secret_deleted_at.absolute'] = (requestParameters['filterSecretDeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretDeletedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_deleted_at.relative_to_now'] = requestParameters['filterSecretDeletedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretDeletedByIds'] != null) {
            queryParameters['filter.secret_deleted_by_ids'] = requestParameters['filterSecretDeletedByIds'];
        }

        if (requestParameters['filterSecretUndeletedAtOperator'] != null) {
            queryParameters['filter.secret_undeleted_at.operator'] = requestParameters['filterSecretUndeletedAtOperator'];
        }

        if (requestParameters['filterSecretUndeletedAtAbsolute'] != null) {
            queryParameters['filter.secret_undeleted_at.absolute'] = (requestParameters['filterSecretUndeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretUndeletedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_undeleted_at.relative_to_now'] = requestParameters['filterSecretUndeletedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretUndeletedByIds'] != null) {
            queryParameters['filter.secret_undeleted_by_ids'] = requestParameters['filterSecretUndeletedByIds'];
        }

        if (requestParameters['filterSecretDestroyedAtOperator'] != null) {
            queryParameters['filter.secret_destroyed_at.operator'] = requestParameters['filterSecretDestroyedAtOperator'];
        }

        if (requestParameters['filterSecretDestroyedAtAbsolute'] != null) {
            queryParameters['filter.secret_destroyed_at.absolute'] = (requestParameters['filterSecretDestroyedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretDestroyedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_destroyed_at.relative_to_now'] = requestParameters['filterSecretDestroyedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretDestroyedByIds'] != null) {
            queryParameters['filter.secret_destroyed_by_ids'] = requestParameters['filterSecretDestroyedByIds'];
        }

        if (requestParameters['filterExpiresOrNextRotationAtOperator'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.operator'] = requestParameters['filterExpiresOrNextRotationAtOperator'];
        }

        if (requestParameters['filterExpiresOrNextRotationAtAbsolute'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.absolute'] = (requestParameters['filterExpiresOrNextRotationAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterExpiresOrNextRotationAtRelativeToNow'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.relative_to_now'] = requestParameters['filterExpiresOrNextRotationAtRelativeToNow'];
        }

        if (requestParameters['paginationPageSize'] != null) {
            queryParameters['pagination.page_size'] = requestParameters['paginationPageSize'];
        }

        if (requestParameters['paginationNextPageToken'] != null) {
            queryParameters['pagination.next_page_token'] = requestParameters['paginationNextPageToken'];
        }

        if (requestParameters['paginationPreviousPageToken'] != null) {
            queryParameters['pagination.previous_page_token'] = requestParameters['paginationPreviousPageToken'];
        }

        if (requestParameters['sortingOrderBy'] != null) {
            queryParameters['sorting.order_by'] = requestParameters['sortingOrderBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/secrets-inventory`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchSecretsInventoryResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchSecretsInventory(requestParameters: VaultReportingServiceApiFetchSecretsInventoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchSecretsInventoryResponse> {
        const response = await this.fetchSecretsInventoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async fetchSecretsInventoryCountRaw(requestParameters: VaultReportingServiceApiFetchSecretsInventoryCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VaultReporting20250505FetchSecretsInventoryCountResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        if (requestParameters['clusterId'] == null) {
            throw new runtime.RequiredError(
                'clusterId',
                'Required parameter "clusterId" was null or undefined when calling fetchSecretsInventoryCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterIncludeDeleted'] != null) {
            queryParameters['filter.include_deleted'] = requestParameters['filterIncludeDeleted'];
        }

        if (requestParameters['filterSecretNames'] != null) {
            queryParameters['filter.secret_names'] = requestParameters['filterSecretNames'];
        }

        if (requestParameters['filterSecretTypes'] != null) {
            queryParameters['filter.secret_types'] = requestParameters['filterSecretTypes'];
        }

        if (requestParameters['filterNamespaces'] != null) {
            queryParameters['filter.namespaces'] = requestParameters['filterNamespaces'];
        }

        if (requestParameters['filterMountPaths'] != null) {
            queryParameters['filter.mount_paths'] = requestParameters['filterMountPaths'];
        }

        if (requestParameters['filterPluginNames'] != null) {
            queryParameters['filter.plugin_names'] = requestParameters['filterPluginNames'];
        }

        if (requestParameters['filterPluginTypes'] != null) {
            queryParameters['filter.plugin_types'] = requestParameters['filterPluginTypes'];
        }

        if (requestParameters['filterCreatedAtOperator'] != null) {
            queryParameters['filter.created_at.operator'] = requestParameters['filterCreatedAtOperator'];
        }

        if (requestParameters['filterCreatedAtAbsolute'] != null) {
            queryParameters['filter.created_at.absolute'] = (requestParameters['filterCreatedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterCreatedAtRelativeToNow'] != null) {
            queryParameters['filter.created_at.relative_to_now'] = requestParameters['filterCreatedAtRelativeToNow'];
        }

        if (requestParameters['filterCreatedByIds'] != null) {
            queryParameters['filter.created_by_ids'] = requestParameters['filterCreatedByIds'];
        }

        if (requestParameters['filterConfigLastModifiedAtOperator'] != null) {
            queryParameters['filter.config_last_modified_at.operator'] = requestParameters['filterConfigLastModifiedAtOperator'];
        }

        if (requestParameters['filterConfigLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.config_last_modified_at.absolute'] = (requestParameters['filterConfigLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_modified_at.relative_to_now'] = requestParameters['filterConfigLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastModifiedByIds'] != null) {
            queryParameters['filter.config_last_modified_by_ids'] = requestParameters['filterConfigLastModifiedByIds'];
        }

        if (requestParameters['filterConfigLastAccessedAtOperator'] != null) {
            queryParameters['filter.config_last_accessed_at.operator'] = requestParameters['filterConfigLastAccessedAtOperator'];
        }

        if (requestParameters['filterConfigLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.config_last_accessed_at.absolute'] = (requestParameters['filterConfigLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.config_last_accessed_at.relative_to_now'] = requestParameters['filterConfigLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigLastAccessedByIds'] != null) {
            queryParameters['filter.config_last_accessed_by_ids'] = requestParameters['filterConfigLastAccessedByIds'];
        }

        if (requestParameters['filterConfigDeletedAtOperator'] != null) {
            queryParameters['filter.config_deleted_at.operator'] = requestParameters['filterConfigDeletedAtOperator'];
        }

        if (requestParameters['filterConfigDeletedAtAbsolute'] != null) {
            queryParameters['filter.config_deleted_at.absolute'] = (requestParameters['filterConfigDeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterConfigDeletedAtRelativeToNow'] != null) {
            queryParameters['filter.config_deleted_at.relative_to_now'] = requestParameters['filterConfigDeletedAtRelativeToNow'];
        }

        if (requestParameters['filterConfigDeletedByIds'] != null) {
            queryParameters['filter.config_deleted_by_ids'] = requestParameters['filterConfigDeletedByIds'];
        }

        if (requestParameters['filterSecretLastModifiedAtOperator'] != null) {
            queryParameters['filter.secret_last_modified_at.operator'] = requestParameters['filterSecretLastModifiedAtOperator'];
        }

        if (requestParameters['filterSecretLastModifiedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_modified_at.absolute'] = (requestParameters['filterSecretLastModifiedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastModifiedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_modified_at.relative_to_now'] = requestParameters['filterSecretLastModifiedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastModifiedByIds'] != null) {
            queryParameters['filter.secret_last_modified_by_ids'] = requestParameters['filterSecretLastModifiedByIds'];
        }

        if (requestParameters['filterSecretLastAccessedAtOperator'] != null) {
            queryParameters['filter.secret_last_accessed_at.operator'] = requestParameters['filterSecretLastAccessedAtOperator'];
        }

        if (requestParameters['filterSecretLastAccessedAtAbsolute'] != null) {
            queryParameters['filter.secret_last_accessed_at.absolute'] = (requestParameters['filterSecretLastAccessedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretLastAccessedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_last_accessed_at.relative_to_now'] = requestParameters['filterSecretLastAccessedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretLastAccessedByIds'] != null) {
            queryParameters['filter.secret_last_accessed_by_ids'] = requestParameters['filterSecretLastAccessedByIds'];
        }

        if (requestParameters['filterSecretDeletedAtOperator'] != null) {
            queryParameters['filter.secret_deleted_at.operator'] = requestParameters['filterSecretDeletedAtOperator'];
        }

        if (requestParameters['filterSecretDeletedAtAbsolute'] != null) {
            queryParameters['filter.secret_deleted_at.absolute'] = (requestParameters['filterSecretDeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretDeletedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_deleted_at.relative_to_now'] = requestParameters['filterSecretDeletedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretDeletedByIds'] != null) {
            queryParameters['filter.secret_deleted_by_ids'] = requestParameters['filterSecretDeletedByIds'];
        }

        if (requestParameters['filterSecretUndeletedAtOperator'] != null) {
            queryParameters['filter.secret_undeleted_at.operator'] = requestParameters['filterSecretUndeletedAtOperator'];
        }

        if (requestParameters['filterSecretUndeletedAtAbsolute'] != null) {
            queryParameters['filter.secret_undeleted_at.absolute'] = (requestParameters['filterSecretUndeletedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretUndeletedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_undeleted_at.relative_to_now'] = requestParameters['filterSecretUndeletedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretUndeletedByIds'] != null) {
            queryParameters['filter.secret_undeleted_by_ids'] = requestParameters['filterSecretUndeletedByIds'];
        }

        if (requestParameters['filterSecretDestroyedAtOperator'] != null) {
            queryParameters['filter.secret_destroyed_at.operator'] = requestParameters['filterSecretDestroyedAtOperator'];
        }

        if (requestParameters['filterSecretDestroyedAtAbsolute'] != null) {
            queryParameters['filter.secret_destroyed_at.absolute'] = (requestParameters['filterSecretDestroyedAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterSecretDestroyedAtRelativeToNow'] != null) {
            queryParameters['filter.secret_destroyed_at.relative_to_now'] = requestParameters['filterSecretDestroyedAtRelativeToNow'];
        }

        if (requestParameters['filterSecretDestroyedByIds'] != null) {
            queryParameters['filter.secret_destroyed_by_ids'] = requestParameters['filterSecretDestroyedByIds'];
        }

        if (requestParameters['filterExpiresOrNextRotationAtOperator'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.operator'] = requestParameters['filterExpiresOrNextRotationAtOperator'];
        }

        if (requestParameters['filterExpiresOrNextRotationAtAbsolute'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.absolute'] = (requestParameters['filterExpiresOrNextRotationAtAbsolute'] as any).toISOString();
        }

        if (requestParameters['filterExpiresOrNextRotationAtRelativeToNow'] != null) {
            queryParameters['filter.expires_or_next_rotation_at.relative_to_now'] = requestParameters['filterExpiresOrNextRotationAtRelativeToNow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }

        const response = await this.request({
            path: `/vault-reporting/2025-05-05/organizations/{organization_id}/projects/{project_id}/clusters/{cluster_id}/reports/secrets-inventory/count`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"cluster_id"}}`, encodeURIComponent(String(requestParameters['clusterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultReporting20250505FetchSecretsInventoryCountResponseFromJSON(jsonValue));
    }

    /**
     */
    async fetchSecretsInventoryCount(requestParameters: VaultReportingServiceApiFetchSecretsInventoryCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VaultReporting20250505FetchSecretsInventoryCountResponse> {
        const response = await this.fetchSecretsInventoryCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum FetchDistinctEntityIdsColumnEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    CREATED_BY_ID = 'CREATED_BY_ID',
    CONFIG_LAST_MODIFIED_BY_ID = 'CONFIG_LAST_MODIFIED_BY_ID',
    CONFIG_LAST_ACCESSED_BY_ID = 'CONFIG_LAST_ACCESSED_BY_ID',
    CONFIG_DELETED_BY_ID = 'CONFIG_DELETED_BY_ID',
    SECRET_LAST_MODIFIED_BY_ID = 'SECRET_LAST_MODIFIED_BY_ID',
    SECRET_LAST_ACCESSED_BY_ID = 'SECRET_LAST_ACCESSED_BY_ID',
    SECRET_DELETED_BY_ID = 'SECRET_DELETED_BY_ID',
    SECRET_UNDELETED_BY_ID = 'SECRET_UNDELETED_BY_ID',
    SECRET_DESTROYED_BY_ID = 'SECRET_DESTROYED_BY_ID'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterCreatedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterConfigLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterConfigLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterConfigDeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretDeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretUndeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterSecretDestroyedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryFilterExpiresOrNextRotationAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterCreatedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterConfigLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterConfigLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterConfigDeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretLastModifiedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretLastAccessedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretDeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretUndeletedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterSecretDestroyedAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
/**
  * @export
  * @enum {string}
  */
export enum FetchSecretsInventoryCountFilterExpiresOrNextRotationAtOperatorEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}
